import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'

export default class RemoveAssistanceCategoryModal extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <SettingRemoveModal
        setting={{ label: 'Hearing', id: 1 }}
        settingType='Assistance Category'
        onRemove={this.onRemove}
        onClose={this.onClose}
      />
    )
  }

  private onRemove = () => {
    console.log('remove')
  }

  private onClose = () => {
    this.props.history.push('/global-settings/assistance-category')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveAssistanceCategoryModal.tsx